import type { NotificationBadgesDataObject, NotificationDataObject, NotificationSettingDataObject } from './service';

export type NotificationSetting = {
  changeAllowed: boolean;
  value: boolean;
};

export const createNotificationSetting = (data: NotificationSettingDataObject): NotificationSetting => ({
  changeAllowed: data.change_allowed,
  value: data.value,
});

export type NotificationBadges = {
  total: number;
};

export const createNotificationBadges = (data: NotificationBadgesDataObject): NotificationBadges => ({
  total: data.total,
});

export type NotificationList = {
  content: string;
  createdAt: string;
  icon: string;
  id: string;
  name: string;
  path: string;
  status: 'read' | 'unread' | 'unseen';
  url: string;
};

export const createNotificationList = (data: NotificationDataObject): NotificationList => ({
  content: data.content,
  createdAt: data.created_at,
  icon: data.icon,
  id: data.id,
  name: data.name,
  path: data.path,
  status: data.status,
  url: data.url,
});
